/* eslint-disable react/jsx-props-no-spreading */
import UIWMDEditor, { MDEditorProps, ICommand } from '@uiw/react-md-editor';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
// assets
import { useMemo } from 'react';
import styles from '@/components/MDEditor/MDEditor.module.css';

// eslint-disable-next-line sonarjs/function-return-type
const handleCommandsFilter = (command: ICommand) => {
    if (
        [
            'comment',
            'strikethrough',
            'link',
            'quote',
            'title',
            'hr',
            'checked-list',
            'help'
        ].includes(command.name ?? '')
    ) {
        return false;
    }
    return command;
};

// Markdown may contain raw HTML (stored XSS vector), so the preview is
// sanitized by whitelist. `language-*` classNames are kept on code blocks
// to preserve syntax highlighting.
const sanitizeSchema: typeof defaultSchema = {
    ...defaultSchema,
    attributes: {
        ...defaultSchema.attributes,
        code: [
            ...(defaultSchema.attributes?.code ?? []),
            ['className', /^language-./]
        ]
    }
};

const sanitizePlugin: [typeof rehypeSanitize, typeof sanitizeSchema] = [
    rehypeSanitize,
    sanitizeSchema
];

const MDEditor = ({ previewOptions, ...props }: MDEditorProps) => {
    const sanitizedPreviewOptions = useMemo(
        () => ({
            ...previewOptions,
            rehypePlugins: [
                sanitizePlugin,
                ...(previewOptions?.rehypePlugins ?? [])
            ]
        }),
        [previewOptions]
    );
    return (
        <div data-color-mode="light">
            <UIWMDEditor
                className={styles.editor}
                commandsFilter={handleCommandsFilter}
                height={400}
                previewOptions={sanitizedPreviewOptions}
                {...props}
            />
        </div>
    );
};

export default MDEditor;
